export default {
  'pages.login.passwordLogin': 'Password',
  'pages.login.codeLogin': 'Verification',
  'pages.login.phone': 'Phone',
  'pages.login.phone.placeholder': 'Your phone number',
  'pages.login.phone.valid': 'please enter a valid phone number',
  'pages.login.code': 'Verification Code',
  'pages.login.code.placeholder': 'Your verification code',
  'pages.login.code.valid': 'Please enter your verification code',
  'pages.login.username': 'Username',
  'pages.login.username.placeholder': 'Your username/phone number',
  'pages.login.username.valid': 'Please enter your username/phone number',
  'pages.login.password': 'Password',
  'pages.login.password.placeholder': 'Your password',
  'pages.login.password.valid': 'Please enter your password',
  'pages.login.register': 'Sign up',
  'pages.login.login': 'Sign in',
  'pages.login.sendCode': 'Send code',
  'pages.login.code.hasSend': ' ',
  'pages.login.captcha.verification': 'Verification Success',
  'pages.login.captcha.click': 'Click here to verify',
  'pages.login.remember': 'Login for 7 Days',
  'pages.login.authorize.ok': 'Auth Sign in',
  'pages.login.authorize.cancel': 'Reject',
  'pages.login.authorize.title': 'Hi! Welcome To Packaging Mall',
  'pages.login.authorize.descPrev':
    'After clicking Authorize to sign in, your account',
  'pages.login.authorize.descNext':
    'will log in to the packaging material mall with one click',
  'pages.login.authorize.subDesc':
    'Note: (After the first activation, your current account will be able to sign in across Beukay platform)',
  'pages.login.loginSuccess': 'Sign in Success',
  'pages.login.sendCode.fail':
    'Failed to send verification code, please resend',
  'pages.login.captcha.tip': 'Please verify',
  'pages.login.password.error': 'Incorrect password',
  'pages.login.code.error': 'Incorrect verification code',

  'pages.register.title': 'User Sign Up',
  'pages.register.companyName': 'Company Name',
  'pages.register.companyName.placeholder': 'Your company name',
  'pages.register.companyName.valid': 'Please enter your company name',
  'pages.register.contact': 'Contact',
  'pages.register.password.valid':
    '8-20 digits, must contain a numbers and letters',
  'pages.register.contact.placeholder': 'Your name',
  'pages.register.contact.valid': 'Please enter your name',
  'pages.register.hasAccount': 'have account?',
  'pages.register.readAndAccept':
    'I confirm that I have read and acknowledge the',
  'pages.register.term': 'term',
  'pages.register.signUp': 'Sign up',
  'pages.register.success': 'Sign up success',
  'pages.register.fail': 'Sign up fail',
  'pages.register.registerTerm': 'User Registration Agreement',
  'pages.register.secretTerm': 'Privacy Policy',
  'pages.register.agree': 'Please agree to the terms first',
  'pages.register.and': 'and',
};
